import { render, staticRenderFns } from "./UserPassportsManager.vue?vue&type=template&id=06c74098&scoped=true&"
import script from "./UserPassportsManager.vue?vue&type=script&lang=js&"
export * from "./UserPassportsManager.vue?vue&type=script&lang=js&"
import style0 from "./UserPassportsManager.vue?vue&type=style&index=0&id=06c74098&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c74098",
  null
  
)

export default component.exports